import { Controller } from "@hotwired/stimulus";

// Builder de widget marketing : aperçu live qui reflète le type d'affichage
// (popup / bandeau / slide-in / bouton flottant / formulaire intégré) et le mode
// (formulaire de capture vs simple CTA bouton). Gestion dynamique des champs.
export default class extends Controller {
  static targets = [
    "form", "fields", "fieldRow", "fieldTemplate", "formSection", "ctaSection",
    "preview", "pvCard", "pvHeadline", "pvDesc", "pvFields", "pvButton",
    "headline", "description", "button", "color", "widgetType", "mode", "buttonUrl"
  ];

  connect() {
    this.refresh();
  }

  addField() {
    const tpl = this.fieldTemplateTarget.content.firstElementChild.cloneNode(true);
    this.fieldsTarget.appendChild(tpl);
    this.refresh();
  }

  removeField(event) {
    const row = event.currentTarget.closest("[data-marketing-widget-builder-target='fieldRow']");
    if (row && this.fieldRowTargets.length > 1) row.remove();
    else if (row) row.querySelectorAll("input").forEach((i) => (i.value = ""));
    this.refresh();
  }

  refresh() {
    const type = this.hasWidgetTypeTarget ? this.widgetTypeTarget.value : "popup";
    const mode = this.hasModeTarget ? this.modeTarget.value : "form";
    const color = this.hasColorTarget ? this.colorTarget.value : "#4f46e5";

    // Affiche/masque les sections selon le mode (plusieurs sections possibles).
    this.formSectionTargets.forEach((el) => (el.hidden = mode !== "form"));
    this.ctaSectionTargets.forEach((el) => (el.hidden = mode !== "cta"));

    // Texte + bouton.
    if (this.hasPvHeadlineTarget) this.pvHeadlineTarget.textContent = this.val("headline") || "Votre titre";
    if (this.hasPvDescTarget) this.pvDescTarget.textContent = this.val("description") || "Votre texte d'accroche.";
    if (this.hasPvButtonTarget) {
      this.pvButtonTarget.textContent = this.val("button") || (mode === "cta" ? "En savoir plus" : "Envoyer");
      this.pvButtonTarget.style.background = color;
    }

    // Champs (uniquement en mode formulaire).
    this.renderFieldsPreview(mode);

    // Classe du conteneur d'aperçu selon le type.
    if (this.hasPvCardTarget) {
      this.pvCardTarget.className = `mkt-wpreview mkt-wpreview--${type}`;
      this.pvCardTarget.style.setProperty("--w-color", color);
    }
  }

  renderFieldsPreview(mode) {
    if (!this.hasPvFieldsTarget) return;
    this.pvFieldsTarget.innerHTML = "";
    if (mode === "cta") return;
    this.fieldRowTargets.forEach((row) => {
      const label = row.querySelector("input[name*='[label]']")?.value || "Champ";
      const type = row.querySelector("select[name*='[type]']")?.value || "text";
      const el = document.createElement(type === "textarea" ? "textarea" : "input");
      if (type !== "textarea") el.type = type === "tel" ? "tel" : type === "email" ? "email" : "text";
      el.placeholder = label;
      el.className = "mkt-wpreview__input";
      el.disabled = true;
      this.pvFieldsTarget.appendChild(el);
    });
  }

  val(name) {
    const has = `has${name.charAt(0).toUpperCase()}${name.slice(1)}Target`;
    return this[has] ? this[`${name}Target`].value : "";
  }
}
